import { render, staticRenderFns } from "./ForgotPasswordConfirmMailForm.vue?vue&type=template&id=3d967e9c&scoped=true&"
import script from "./ForgotPasswordConfirmMailForm.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordConfirmMailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d967e9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
